import NextLink from 'next/link'
import { LinkStyled } from './styled'

export function Link({ href, as, isSubtask, ...props }) {
  return (
    <NextLink href={href} as={as}>
      <LinkStyled href={as || href} $isSubtask={isSubtask} {...props} />
    </NextLink>
  )
}
